import { features, statsData } from '@/mocks/features';

export default function FeatureSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            为什么选择91影视看片app？
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            超过5000万用户的选择，我们用实力证明——好的观影体验不需要付费
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-200 transition-all duration-300 hover:translate-y-[-2px] group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-6">
          {statsData.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">
                {stat.value}
              </div>
              <div className="text-foreground-500 text-xs md:text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}